import { forwardRef } from "react";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities//getHtmlPropsFromBaseProps";
import { useId } from "../../hooks/useId";
import { LoadingGroup } from "capitalrx-components-2.0/lib/general";
import { SelectInstance } from "react-select";
import { InputContainer } from "../shared";
import { DropdownProps } from "./Dropdown";
import { useInputDisabled, useInputReadonly } from "../InputGroup";
import { Placeholder } from "./Placeholder";
import { OptionItem } from "./OptionItem";
import { SharedDropdown } from "./SharedDropdown";
import styles from "./styles.module.scss";


export interface InputProps extends DropdownProps {
  /**
   * Indicates whether the input is required.
   */
  readonly required?: boolean;
}

export const Input = forwardRef<SelectInstance<OptionItem | null, boolean>, InputProps>(function Input(props, ref) {
  const { label, instructions, tooltip, required = false, children, hideInstructions, hideLabel } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Dropdown, "nu-dropdown"], // TODO: rename this to "dropdown" when the global style that's breaking things is gone.
    testIdPrefix: "dropdown",
  });

  const id = useId();
  const disabled = useInputDisabled(props);
  const readOnly = useInputReadonly(props);

  return (
    <LoadingGroup.Placeholder fallback={<Placeholder className={props.className} style={props.style} />}>
      <InputContainer
        {...getBasePropsFromHtmlProps(baseHtmlProps)}
        id={id}
        label={label}
        instructions={instructions}
        disabled={disabled}
        readOnly={readOnly}
        tooltip={tooltip}
        required={required}
        hideInstructions={hideInstructions}
        hideLabel={hideLabel}
      >
        <SharedDropdown {...props} id={id} ref={ref}>
          {children}
        </SharedDropdown>
      </InputContainer>
    </LoadingGroup.Placeholder>
  );
});
